import {useState} from "react";
import {useAppContext} from "../../../contexts/AppContext";

// Избор на землища за права (Г5). Чипове + търсене през datalist от активните
// землища (AppContext.settlements = /part-settlements, за админ = всички активни).
// Празен списък = без ограничение (достъп до всички).
export const UserSettlementsPicker = ({value, onChange}) => {
    const {settlements} = useAppContext();
    const [input, setInput] = useState('');

    const byEkatte = {};
    settlements.forEach(s => { byEkatte[s.ekatte] = s; });

    const add = (ekatte) => {
        const ek = (ekatte || '').trim();
        if (!ek || value.includes(ek) || !byEkatte[ek]) return;
        onChange([...value, ek]);
        setInput('');
    };

    const remove = (ekatte) => onChange(value.filter(e => e !== ekatte));

    const tryAddFrom = (text) => {
        const m = text.match(/\((\d+)\)\s*$/); // „Име (ЕКАТТЕ)"
        add(m ? m[1] : text);
    };

    return (
        <div>
            <div className="mb-2 d-flex flex-wrap gap-1">
                {value.length === 0 && (
                    <span className="text-muted">Без ограничение — достъп до всички землища.</span>
                )}
                {value.map(ek => (
                    <span key={ek} className="badge bg-secondary d-inline-flex align-items-center">
                        {byEkatte[ek] ? `${byEkatte[ek].settlement} (${ek})` : ek}
                        <button type="button" className="btn-close btn-close-white ms-2"
                                style={{fontSize: '0.55rem'}} aria-label="Премахни"
                                onClick={() => remove(ek)}></button>
                    </span>
                ))}
            </div>
            <input className="form-control" list="admin-settlements-list"
                   placeholder="Търси землище по име/ЕКАТТЕ и добави…"
                   value={input}
                   onChange={e => {
                       const v = e.target.value;
                       setInput(v);
                       // При избор от datalist стойността е „Име (ЕКАТТЕ)" → добави веднага.
                       if (/\(\d+\)\s*$/.test(v)) tryAddFrom(v);
                   }}
                   onKeyDown={e => {
                       if (e.key === 'Enter') {
                           e.preventDefault();
                           tryAddFrom(input);
                       }
                   }}/>
            <datalist id="admin-settlements-list">
                {settlements.map(s => (
                    <option key={s.ekatte} value={`${s.settlement} (${s.ekatte})`}/>
                ))}
            </datalist>
        </div>
    );
};
